import React from 'react'

import PropTypes from 'prop-types'

import './store-banner.css'

const StoreBanner = ({
  imageSrc = '/app-store-badge-200h.png',
  imageAlt = 'Download on the App Store',
  imageSrc1 = '/google-play-badge-200h.png',
  imageAlt1 = 'Get it on Google Play',
  appStoreUrl = 'https://apps.apple.com/au/app/dance-local%C3%A9/id6748289759',
  googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.yadawn.dancelocale&pcampaignid=web_share'
}) => {
  // Debug logging (remove later)
  // console.log('StoreBanner props:', { imageSrc, imageAlt, imageSrc1, imageAlt1 });

  return (
    <div className="store-banner-store-banner">
      <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
        <img
          alt={imageAlt1}
          src={imageSrc1}
          className="store-banner-image1"
        />
      </a>
      <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
        <img
          alt={imageAlt}
          src={imageSrc}
          className="store-banner-image2"
        />
      </a>
    </div>
  )
}

StoreBanner.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageAlt: PropTypes.string,
  appStoreUrl: PropTypes.string,
  googlePlayUrl: PropTypes.string,
}

export default StoreBanner
